module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-0-75.a5b114a3.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-0-75.png
// module id = 2549
// module chunks = 11